export interface HeaderMenuConfig {
  about: boolean;
  explore: boolean;
  troupeRegister: boolean;
  raRegister: boolean;
  help: boolean;
  analytics: boolean;
  checkStatus: boolean;
  notifications: boolean;
  urgentBanner: boolean;
}

const STORAGE_KEY = 'ctms_header_menu_config';

export const DEFAULT_HEADER_MENU_CONFIG: HeaderMenuConfig = {
  about: true,
  explore: true,
  troupeRegister: true,
  raRegister: true,
  help: true,
  analytics: true,
  checkStatus: true,
  notifications: true,
  urgentBanner: false,
};

export function getHeaderMenuConfig(): HeaderMenuConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return { ...DEFAULT_HEADER_MENU_CONFIG, ...JSON.parse(raw) };
    }
  } catch (e) {
    // fallback
  }
  return { ...DEFAULT_HEADER_MENU_CONFIG };
}

export function saveHeaderMenuConfig(config: HeaderMenuConfig): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('headerMenuConfigChange', { detail: config }));
    }
  } catch (e) {
    // ignore
  }
}
